export default __webpack_public_path__ + "static/media/one.4daacdd9.jpg";